import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["longDescription", "btnText", "expandableBlock", "btn",
                    "expandableContainer", "scrollAnchor"];

  toggle() {
    this.expandableContainerTarget.classList.toggle('open')
    this.btnTextTarget.classList.toggle('open')
    this.btnTarget.classList.toggle('open')
  }

  expandContainer(event) {
    const block = this.expandableBlockTargets.find(target => target.contains(event.currentTarget));
    const expandable = this.expandableContainerTargets.find(target => block.contains(target));
    expandable.classList.toggle('expanded');
    event.currentTarget.classList.toggle('expanded');

    if (expandable.style.maxHeight) {
        expandable.style.maxHeight = null;
        expandable.style.height = expandable.style.minHeight;
    } else {
        expandable.style.height = expandable.scrollHeight + "px";
        expandable.style.maxHeight = expandable.scrollHeight + "px";
    }
  }
}
